import { CreateResumeDto, ResumeDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { RESUMES_KEY } from "@/client/constants/query-keys";
import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";

import { updateResume } from "./update";

const LPU_RESUME_HOST = "resume.lpu.in";

const isLpuResumeSite = () =>
  typeof window !== "undefined" && window.location.hostname.includes(LPU_RESUME_HOST);

export const createResume = async (data: CreateResumeDto) => {
  const response = await axios.post<ResumeDto, AxiosResponse<ResumeDto>, CreateResumeDto>(
    "/resume",
    data,
  );

  let resume = response.data;

  if (isLpuResumeSite()) {
    resume = await updateResume({
      ...resume,
      data: {
        ...resume.data,
        metadata: {
          ...resume.data.metadata,
          template: "Create Custom",
        },
      },
    });
  }

  return resume;
};

export const useCreateResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: createResumeFn,
  } = useMutation({
    mutationFn: createResume,
    onSuccess: (data) => {
      queryClient.setQueryData<ResumeDto>(["resume", { id: data.id }], data);

      queryClient.setQueryData<ResumeDto[]>(RESUMES_KEY, (cache) => {
        if (!cache) return [data];
        return [...cache, data];
      });
    },
  });

  return { createResume: createResumeFn, loading, error };
};
